import { DeleteOutlined, EyeOutlined, MoreOutlined, SettingOutlined } from "@ant-design/icons";
import { Button, Dropdown, Space, Switch,  Tag} from "antd";
import moment from "moment";
import { NoData } from "../../utils";


export const ColumnsMerchant = (
    accessible_details,
    accessible_setup,
    t,
    FormatTimeAgo,
    CheckAdminType,
    idMerchant,
    loadingSwitch,
    onChangeStatus,
    handleShowDetailsModel,
    handleShowModelSetFeesModel,
    handleShowSetMin_withdraw_deposit_Model,
    admin_type,
    dropdownPlacement
) => [
        // id
        {
            title: "ID",
            key: "id",
            dataIndex: "id",
            render: (id, record, index) => (
                <u onClick={() => accessible_details ? handleShowDetailsModel(record) : alert(t("You do not have permission to view details."))}
                    className={`hover text-center `}
                    style={{ cursor: "pointer", color: record.id === parseInt(idMerchant) ? "#007bff" : "inherit" }}
                >
                    #{id}
                </u>
            ),
            sorter: false,
        },
        // merchant
        {
            title: t("Merchant"),
            dataIndex: "name",
            key: "name",
            render: (name, record) => (
                <span style={{ maxWidth: "60px" }} className="text-truncate">
                    {name || NoData()}
                </span>
            ),
        },
        // Status
        {
            title: t("Status"),
            dataIndex: "isActive",
            key: "isActive",
            render: (status, record) => {
                return (
                    <>
                        {admin_type ? (
                            <Switch
                                loading={loadingSwitch}
                                checkedChildren={<>{t("enabled")}</>}
                                size="small"
                                unCheckedChildren={<>{t("disabled")}</>}
                                disabled={record?.id !== parseInt(idMerchant)}
                                checked={status}
                                onChange={(checked) => onChangeStatus(checked, record, "status")}
                            />
                        ) : (<Tag color={status ? "success" : "error"}>{status ? t("enabled") : t("disabled")}</Tag>)}
                    </>
                );
            },
        },

        // Min Payin
        {
            title: t("Min Payin"),
            dataIndex: "deposit_minlimit",
            key: "deposit_minlimit",
            render: (deposit_minlimit) => (
                <span style={{ textTransform: "uppercase" }}>
                    {Intl.NumberFormat().format(
                        parseFloat(deposit_minlimit).toFixed(2),
                    )}
                </span>
            ),
        },

        // Min Payout
        {
            title: t("Min Payout"),
            dataIndex: "witdrow_minlimit",
            key: "witdrow_minlimit",
            render: (o) => (
                <span style={{ maxWidth: "60px" }} className="text-truncate">
                    {Intl.NumberFormat().format(parseFloat(o).toFixed(2))}
                </span>
            ),
        },

        // Payin Fee
        {
            title: t("Payin Fee"),
            dataIndex: "FeeSetting",
            key: "FeeSetting",
            render: (record) => {
                const Fee = record?.depositFeePercentage;
                return (
                    <span style={{ maxWidth: "60px" }} className="text-truncate">
                        {Fee ? (
                            Intl.NumberFormat().format(parseFloat(Fee).toFixed(2))
                        ) : (
                            <small>
                                <em style={{ color: "#888" }}>{t("Fee not set yet")}</em>
                            </small>
                        )}
                    </span>
                );
            },
        },

        // Payout Fee
        {
            title: t("Payout Fee"),
            dataIndex: "FeeSetting",
            key: "FeeSetting",
            render: (record) => {
                const Fee = record?.withdrawalFeePercentage;
                return (
                    <span style={{ maxWidth: "60px" }} className="text-truncate">
                        {Fee ? (Intl.NumberFormat().format(parseFloat(Fee).toFixed(2))) : (
                            <small>
                                <em style={{ color: "#888" }}>{t("Fee not set yet")}</em>
                            </small>
                        )}
                    </span>
                );
            },
        },

        // Verify Slip Fee
        {
            title: t("Verify Slip Fee"),
            dataIndex: "FeeSetting",
            key: "FeeSetting",
            render: (record) => (
                <span style={{ maxWidth: "60px" }} className="text-truncate">
                    {Intl.NumberFormat().format(parseFloat(record?.deposit_fee_slep).toFixed(2))}
                </span>
            ),
        },

        // Verify Acc. Fee
        {
            title: t("Verify Acc. Fee"),
            dataIndex: "FeeSetting",
            key: "FeeSetting",
            render: (record) => (
                <span style={{ maxWidth: "60px" }} className="text-truncate">
                    {record?.verifyAccountFee
                        ? Intl.NumberFormat().format(parseFloat(record?.verifyAccountFee).toFixed(2))
                        : 0}
                </span>
            ),
        },

        // createdAt
        {
            title: t("createdAt"),
            dataIndex: "created_at",
            key: "created_at",
            render: (date) => (
                <span
                    title={moment(date).format("DD-MM-YYYY HH:mm:ss")}
                    className="text-truncate"
                    style={{ maxWidth: "60px" }}
                >
                    {FormatTimeAgo(date)}
                </span>
            ),
        },

        // action
        {
            title: t("action"),
            render: (record) => {
                let view = CheckAdminType("setFees");
                const menuItems = [];
                if (accessible_details) {
                    menuItems.push({
                        key: "Details",
                        icon: <EyeOutlined />,
                        label: <>{t("Details")}</>,
                        onClick: () => handleShowDetailsModel(record),
                    },);
                }
                if (!view && accessible_setup) {
                    menuItems.push({
                        key: "SettingOutlined2",
                        icon: <SettingOutlined />,
                        label: <>{t("Setting")}</>,
                        onClick: () => handleShowSetMin_withdraw_deposit_Model(record),
                    },);
                }

                // สำหรับ Developer หรือ Super Admin ที่มีสิทธิ์ทั้งสองอย่างนี้ จะเห็นเมนูทั้งสองอันนี้
                if (view && accessible_setup) {
                    menuItems.push({
                        key: "SettingOutlined1",
                        icon: <SettingOutlined />,
                        label: <>{t("Setting")}</>,
                        onClick: () => handleShowModelSetFeesModel(record),
                    },);
                }
                if (admin_type) {
                    menuItems.push({ // สำหรับ Developer หรือ Super Admin ที่มีสิทธิ์ทั้งสองอย่างนี้ จะเห็นเมนูทั้งสองอันนี้
                        key: "Delete",
                        icon: <DeleteOutlined />,
                        label: <>{t("Delete")}</>,
                        disabled: record?.id !== parseInt(idMerchant),
                        style: {
                            color: "red"
                        },
                        onClick: () => onChangeStatus("", record, "del"),

                    },);
                }
                return (
                    <Space size="middle">
                        {record.isActive ? (
                            <>
                                <div className="md-show">
                                    {menuItems.length > 0 && (<Dropdown
                                        arrow={true}
                                        trigger={["click"]}
                                        placement={dropdownPlacement || "bottomRight"}
                                        align="start"
                                        menu={{
                                            items: menuItems
                                        }}
                                    >
                                        <Button shape="circle">
                                            <MoreOutlined
                                                style={{ color: "#5A5A5A" }}
                                                id="MoreOutlined"
                                            />
                                        </Button>
                                    </Dropdown>)}

                                </div>
                            </>
                        ) : null}
                    </Space>
                );
            },
        },
    ]